import { Box, Button, Typography } from "@mui/material";
import { incidentsApi } from "incidents/api";
import PrivateLayout from "layouts/PrivateLayout";
import { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { primaryButtonSx, usePhrase } from "./common";

export default function IncidentExportPage({ preview = false }: { preview?: boolean }) {
  const { id = "" } = useParams();
  const phrase = usePhrase();
  const frame = useRef<HTMLIFrameElement>(null);
  const [html, setHtml] = useState("");
  const [error, setError] = useState<string | null>(null);
  const base = preview ? "/dev/incidents" : "/incidents";

  useEffect(() => {
    incidentsApi
      .export(id)
      .then((payload) => setHtml(payload.html))
      .catch((err: Error) => setError(err.message));
  }, [id]);

  const body = (
    <Box>
      <Box display="flex" gap={1} mb={2} flexWrap="wrap">
        <Button component={Link} to={`${base}/${id}`} sx={primaryButtonSx}>
          {phrase("Back to record", "Retour au dossier")}
        </Button>
        <Button sx={primaryButtonSx} onClick={() => frame.current?.contentWindow?.print()}>
          {phrase("Print", "Imprimer")}
        </Button>
      </Box>
      <Typography component="h1" sx={{ fontSize: 24, fontWeight: 700, mb: 1 }}>
        {phrase("Printable record", "Dossier imprimable")}
      </Typography>
      <Typography sx={{ mb: 2 }}>
        {phrase(
          "Copy this into the official form. NeuraVue does not submit it.",
          "Copiez ceci dans le formulaire officiel. NeuraVue ne le soumet pas."
        )}
      </Typography>
      {error ? (
        <Typography role="alert" color="error">
          {error}
        </Typography>
      ) : null}
      <Box
        component="iframe"
        ref={frame}
        title={phrase("Printable incident record", "Dossier d'incident imprimable")}
        srcDoc={html}
        sx={{ width: "100%", minHeight: "80vh", border: "1px solid #C5CAD3", bgcolor: "#fff", borderRadius: 1 }}
      />
    </Box>
  );

  if (preview) return <Box sx={{ p: 2 }}>{body}</Box>;
  return <PrivateLayout canAccess={() => true}>{body}</PrivateLayout>;
}
